import cn from 'classnames';
import Link from 'next/link';
import { ReactNode } from 'react';
import styles from './sidebar.module.scss';


type ComponentProps = {
    active?: boolean;
    className?: string
    href: string
    icon: ReactNode
    label: ReactNode
    title?: string
    onClick?: () => void
}


export const SidebarItem = ({ icon, label, href, active, className, title, onClick }: ComponentProps) => {
    return (
        <Link
            href={ href }
            className={ cn(styles.item, { [styles.active]: active }, className) }
            title={ title }
            onClick={ onClick }
        >
            { icon }
            { label }
        </Link>
    );
};
